// extracted by mini-css-extract-plugin
export default {"container":"container-d_gpZ","trustBanner":"trustBanner-XJ613","map":"map-NPEfI","title":"title-FsMeQ","body":"body-DKKii","loadingWheel":"loadingWheel-_t7bQ"};